var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseButton',{attrs:{"data-test-id":"continue-with-social-account-btn","style-modifier":_vm.authProvider},on:{"click":function($event){return _vm.continueWithSocialAccount()}}},[_vm._v(" Continuar con "+_vm._s(_vm.authProvider)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }